
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop value  表格数据
 */
@Component({
    name: 'bulletin-table'
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]

    onTapDetail(id: any) {
        window.open(`/setting/help/article/${id}`)
    }
}
